import { LevelEnum } from '__generatedTypes__/globalTypes'
import { findOneQuestionPassage_findOneQuestionPassage_subject as _Subject } from '__generatedTypes__/findOneQuestionPassage'
import { validateRequiredNumber } from 'utils/validation'

export type Subject = Omit<_Subject, '__typename'>

export const MIN_QUESTIONS_COUNT = 2
export const MAX_QUESTIONS_COUNT = 4
export const CARS_SPEED_READING_GAME = 'speed-reading-game'
export const CARS_MINI_PASSAGE_GAME = 'mini-passage-game'
export const CARS_VOCAB_IDENTIFIER_GAME = 'vocab-identifier-game'
export const MAIN_IDEA_GAME = 'main-idea-game'

export const LEVEL_DIFFICULTY = Object.entries(LevelEnum).map((e, i) => ({
  id: LevelEnum[`Level${i + 1}` as keyof typeof LevelEnum],
  title: `Level ${i + 1}`,
}))

export type LevelOption = (typeof LEVEL_DIFFICULTY)[number]

export const getLevelOption = (level: LevelEnum) => LEVEL_DIFFICULTY.find((l) => l.id === level) as LevelOption

export const getQuestionsCount = (subject: Subject | null | undefined, currentQuestionsCount = 0): number => {
  if (!subject || subject.slug === CARS_MINI_PASSAGE_GAME) {
    return Math.max(Math.min(currentQuestionsCount, MAX_QUESTIONS_COUNT), MIN_QUESTIONS_COUNT)
  }

  if (subject.slug === CARS_SPEED_READING_GAME) {
    return 2
  }

  if (subject.slug === CARS_VOCAB_IDENTIFIER_GAME) {
    return 1
  }

  if (subject.slug === MAIN_IDEA_GAME) {
    return 1
  }

  return MAX_QUESTIONS_COUNT
}

export function validateRequireQuestionsCount(value?: string) {
  const numberError = validateRequiredNumber(value)

  return (
    numberError ||
    (value && (+value < MIN_QUESTIONS_COUNT || +value > MAX_QUESTIONS_COUNT)
      ? `Must be from ${MIN_QUESTIONS_COUNT} to ${MAX_QUESTIONS_COUNT}`
      : undefined)
  )
}
